import { isDropBoxDocument } from '@/helpers/file.helper';
import { PropertyHelper } from '@/helpers/property.helper';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Document, DropBoxDocument } from '@eemo/api-client';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';

export interface PdfViewerDialogData {
  doc: Document | DropBoxDocument;
  urlOverride?: string;
  validateMode?: boolean;
}

@Component({
  selector: 'app-pdf-viewer-dialog',
  templateUrl: './pdf-viewer-dialog.component.html',
  styleUrls: ['./pdf-viewer-dialog.component.scss'],
  standalone: true,
  imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, PdfJsViewerModule, NgIf, MatProgressSpinnerModule]
})
export class PdfViewerDialogComponent implements OnInit {
  dialogTitle: string;
  docUrl: string;
  docFilename: string;
  loading = true;

  constructor(
    public dialogRef: MatDialogRef<PdfViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PdfViewerDialogData,
    private propHelper: PropertyHelper
  ) {
    this.dialogTitle = this.data.doc.name;
    this.dialogRef.updateSize('95vw');
  }

  ngOnInit(): void {
    this.docUrl = this.data.urlOverride
      ? this.data.urlOverride
      : isDropBoxDocument(this.data.doc)
      ? this.propHelper.getDropBoxDocumentFullUrl(this.data.doc)
      : this.propHelper.getDocumentFullUrl(this.data.doc);
    this.docFilename = this.propHelper.getDocumentFilename(this.data.doc);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDocumentLoad(event) {
    this.loading = false;
  }

  docValidated() {
    this.dialogRef.close(true);
  }
}
